import React, { Component } from 'react';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, Button } from 'react-bootstrap';

import { useStore } from '../../../../store';
import CustomDropdownToggle from '../../../../facturotopia/CustomDropdownToggle';

class ComprobantesTypeFilter extends Component {
  state = {};
  timerId = null;

  handleOnSelectComprobanteFilter = (name, filter) => {
    this.setState({
      [name]: filter !== '' ? filter : '',
    });

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    this.timerId = setTimeout(() => {
      this.submit();
    }, 5000);
  };

  submit = () => {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      ...this.state,
    });
  };

  getTypeLegend = () => {
    const { type } = this.state;
    let legend = '';

    switch (type) {
      case 'I':
        legend = 'Ingreso';
        break;

      case 'E':
        legend = 'Egreso';
        break;

      case 'P':
        legend = 'Pagos';
        break;

      case 'N':
        legend = 'Nómina';
        break;

      case 'T':
        legend = 'Traslados';
        break;

      default:
        break;
    }

    return legend;
  };

  getStatusLegend = () => {
    const { status } = this.state;
    let legend = '';

    switch (status) {
      case '1':
        legend = 'Vigentes';
        break;

      case '-1':
        legend = 'Cancelados';
        break;

      default:
        break;
    }

    return legend;
  };

  getClassificationLegend = () => {
    const { clasificacion } = this.state;
    let legend = '';

    switch (clasificacion) {
      case '2':
        legend = 'Factura Manual';
        break;

      case '3':
        legend = 'Facturas Masivas';
        break;

      case '4,5':
        legend = 'Autofacturación';
        break;

      case '6':
        legend = 'Factura Global';
        break;

      default:
        break;
    }

    return legend;
  };

  render() {
    return (
      <div className="mb-1 float-left">
        <Dropdown
          onSelect={this.handleOnSelectComprobanteFilter.bind(this, 'type')}
          className="float-left mr-1 pb-2"
        >
          <Dropdown.Toggle as={CustomDropdownToggle}>{this.getTypeLegend() || 'Tipo'}</Dropdown.Toggle>

          {/*
            TODO
            - Corregir filtrado de acuerdo al permiso asignado ó en cuestión
          */}

          <Dropdown.Menu>
            {Guardian.allows('factura.listar.todos') && <Dropdown.Item eventKey="">Todos</Dropdown.Item>}
            {Guardian.allows('factura.listar.ingreso') && <Dropdown.Item eventKey="I">Ingreso</Dropdown.Item>}
            {Guardian.allows('factura.listar.egreso') && <Dropdown.Item eventKey="E">Egreso</Dropdown.Item>}
            {Guardian.allows('factura.listar.pago') && <Dropdown.Item eventKey="P">Pago</Dropdown.Item>}
            {Guardian.allows('factura.listar.nomina') && <Dropdown.Item eventKey="N">Nómina</Dropdown.Item>}
            {Guardian.allows('factura.listar.traslado') && <Dropdown.Item eventKey="T">Traslados</Dropdown.Item>}
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown
          onSelect={this.handleOnSelectComprobanteFilter.bind(this, 'status')}
          className="float-left mr-1 pb-2"
        >
          <Dropdown.Toggle as={CustomDropdownToggle}>{this.getStatusLegend() || 'Status'}</Dropdown.Toggle>

          <Dropdown.Menu>
            {Guardian.allows('factura.listar.todos') && <Dropdown.Item eventKey="">Todos</Dropdown.Item>}
            {Guardian.allows('factura.listar.vigentes') && <Dropdown.Item eventKey="1">Vigentes</Dropdown.Item>}
            {Guardian.allows('factura.listar.cancelados') && <Dropdown.Item eventKey="-1">Cancelados</Dropdown.Item>}
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown
          onSelect={this.handleOnSelectComprobanteFilter.bind(this, 'clasificacion')}
          className="float-left mr-5 pb-2"
        >
          <Dropdown.Toggle as={CustomDropdownToggle}>
            {this.getClassificationLegend() || 'Clasificación'}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {Guardian.allows('factura.listar.todos') && <Dropdown.Item eventKey="">Todos</Dropdown.Item>}
            {Guardian.allows('factura.listar.manual') && <Dropdown.Item eventKey="2">Factura Manual</Dropdown.Item>}
            {Guardian.allows('factura.listar.masiva') && <Dropdown.Item eventKey="3">Facturación Masiva</Dropdown.Item>}
            {Guardian.allows('factura.listar.autofacturacion') && (
              <Dropdown.Item eventKey="4,5">Autofacturación</Dropdown.Item>
            )}
            {Guardian.allows('factura.listar.global') && <Dropdown.Item eventKey="6">Factura Global</Dropdown.Item>}
          </Dropdown.Menu>
        </Dropdown>

        <Button
          variant="secondary"
          className="text-muted float-xs-right float-sm-right float-md-left"
          onClick={this.submit}
        >
          Aplicar
        </Button>
      </div>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(ComprobantesTypeFilter);
